const isJSON = (value) => {
  try {
    const parsedValue = JSON.parse(value);

    return typeof parsedValue === 'object' && parsedValue !== null;
  } catch (e) {
    return false;
  }
};

export default isJSON;
